"use strict";

const ProductStatus = {
  Discontinued: "DISCONTINUED",
  NotReleasedForSale: "NOT_RELEASED_FOR_SALE",
  ReleasedForSale: "RELEASED_FOR_SALE",
  NotFound: "NOT_FOUND",
  StopStatus: "STOP_STATUS",

  //properties allows you do do something like ProductStatus.properties['DISCONTINUED'].code to get the status code
  properties: {
    DISCONTINUED: { stringKey: "discontinued", code: 2 },
    NOT_RELEASED_FOR_SALE: { stringKey: "notReleasedForSale", code: 9 },
    RELEASED_FOR_SALE: { stringKey: "", code: 10 },
    STOP_STATUS: { stringKey: "stopStatus", code: 5 },
    NOT_FOUND: { stringKey: "", code: 0 }
  }
};

module.exports = ProductStatus;
